import React, {Component} from 'react';
import {connect} from "react-redux";
import MiddlewareStatus from "./MiddlewareStatus";
import EidStatus from "./EidStatus";
import EidPin from "./EidPin";
import EidWrongPin from "./EidWrongPin";
import EidAuthenticationError from "./EidAuthenticationError";

class EidLogin extends Component {

    render() {
        return (
                <div id="eid-content">
                    <MiddlewareStatus/>
                    <EidStatus/>
                    <EidAuthenticationError/>
                    <EidWrongPin/>
                    <EidPin/>
                </div>
        )
    }

}

export default connect(
    (state) => {
        return {
            middlewareRunning: state.eid.middlewareRunning
        }
    },
    (dispatch) => {
        return {

        }
    }
)(EidLogin);


// WEBPACK FOOTER //
// ./src/components/EidLogin.js